import apiClient from './axios';

/**
 * Product Enquiry-related API services
 */
const productEnquiryService = {
  /**
   * Submit a product enquiry
   * @param {Object} formData - The enquiry form data
   * @param {string} formData.name - Customer's name
   * @param {string} formData.email - Customer's email
   * @param {string} formData.mobile - Customer's mobile number
   * @param {string} formData.location - Customer's location/city
   * @param {string} formData.quantity - Product quantity required
   * @param {string} formData.message - Customer's message
   * @param {string} formData.productId - ID of the product being enquired about
   * @param {string} formData.productName - Name of the product being enquired about
   * @returns {Promise} - API response promise
   */
  submitEnquiry: async (formData) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.name?.trim()) throw new Error('Name is required');
    if (!formData.email?.trim() || !emailRegex.test(formData.email)) throw new Error('Valid email is required');
    if (!formData.mobile?.trim() || !phoneRegex.test(formData.mobile.replace(/[\s-]/g, ''))) throw new Error('Valid 10-digit mobile number is required');
    if (!formData.location?.trim()) throw new Error('Location is required');
    if (!formData.quantity?.trim()) throw new Error('Quantity is required');

    const apiPayload = {
      fullName: formData.name.trim(),
      email: formData.email.trim(),
      phone_no: formData.mobile.trim(),
      address: formData.location.trim(),
      message: (formData.message || `Interested in ${formData.productName}`).trim(),
      quantity: formData.quantity.trim()
    };
    
    try {
      const response = await apiClient.post('/api/admin/send', apiPayload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default productEnquiryService;
